import { render } from "./ChoixTypeAlimentationSurface.vue?vue&type=template&id=63e0d26b"
import script from "./ChoixTypeAlimentationSurface.vue?vue&type=script&lang=js"
export * from "./ChoixTypeAlimentationSurface.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__